import { restApi } from '../../services/api';
import { CreateNpsBody } from './nps.types';

const NpsRepository = {
  createNps: (data: CreateNpsBody) => restApi.post<void>('net-promoter-score', data),
};

export default NpsRepository;
